import { SimpleForm, TextInput, ArrayInput, SimpleFormIterator, useEditContext } from 'react-admin';
import { Box, Typography, Card, CardContent } from '@mui/material';
import { JsonField } from './JsonField';
import { FamilyField } from './FamilyField';

interface VariantSkuFormProps {
  toolbar: React.ReactElement;
}

/**
 * Form for editing variant SKU details
 * Includes product identifiers and custom JSON fields
 */
export const VariantSkuForm = ({ toolbar }: VariantSkuFormProps) => {
  const { record } = useEditContext();

  return (
    <SimpleForm toolbar={toolbar}>

      <Box sx={{ width: '100%', maxWidth: 1200 }}>
        {/* Display SKU identifier */}
        <Card sx={{ mb: 3 }}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Variant Information
            </Typography>
            <Typography variant="body2" color="text.secondary">
              SKU: 
              {' '}
              {record?.sku}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Parent SKU: 
              {' '}
              {record?.parentSku}
            </Typography>
          </CardContent>
        </Card>

        {/* Product Identifiers */}
        <Card sx={{ mb: 3 }}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Product Identifiers
            </Typography>

            <ArrayInput source="upc" label="UPC">
              <SimpleFormIterator inline disableReordering>
                <TextInput source="" label="UPC" helperText={false} />
              </SimpleFormIterator>
            </ArrayInput>

            <ArrayInput source="mpn" label="MPN (Manufacturer Part Number)">
              <SimpleFormIterator inline disableReordering>
                <TextInput source="" label="MPN" helperText={false} />
              </SimpleFormIterator>
            </ArrayInput>

            <ArrayInput source="gtin" label="GTIN (Global Trade Item Number)">
              <SimpleFormIterator inline disableReordering>
                <TextInput source="" label="GTIN" helperText={false} />
              </SimpleFormIterator>
            </ArrayInput>

            <ArrayInput source="partnerSku" label="Partner SKU">
              <SimpleFormIterator inline disableReordering>
                <TextInput source="" label="Partner SKU" helperText={false} />
              </SimpleFormIterator>
            </ArrayInput>

            <ArrayInput source="partnerParentSku" label="Partner Parent SKU">
              <SimpleFormIterator inline disableReordering>
                <TextInput source="" label="Partner Parent SKU" helperText={false} />
              </SimpleFormIterator>
            </ArrayInput>
          </CardContent>
        </Card>

        {/* Custom JSON Fields */}
        <Card sx={{ mb: 3 }}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Custom Fields
            </Typography>

            <FamilyField />
            <JsonField source="data" label="Data (JSON)" />
          </CardContent>
        </Card>

      </Box>
    </SimpleForm>
  );
};
